import { IVisaPrepForm } from '../../../../../../types';
import { isPersonTravellingWith } from '../../../../../../utilities/pages';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasGuardiansPersonalDetails'
  | 'guardianNationality'
  | 'guardianSameNationality'
  | 'guardianFamilyName'
  | 'guardianGivenName'
  | 'guardianDob'
  | 'guardianPlaceOfBirth'
  | 'guardianTravellingWith'
  | 'guardianUkVisa'
  | 'guardianHasPassport'
  | 'guardianPassportNumber'
>;

type Params = Fields & {
  dobError: string;
};

export function getPageStatus({
  hasGuardiansPersonalDetails,
  guardianNationality,
  guardianSameNationality,
  guardianFamilyName,
  guardianGivenName,
  guardianDob,
  guardianPlaceOfBirth,
  guardianTravellingWith,
  guardianUkVisa,
  guardianHasPassport,
  guardianPassportNumber,
  dobError,
}: Params): { complete: boolean } {
  let complete = true;

  if (
    hasGuardiansPersonalDetails === undefined ||
    (hasGuardiansPersonalDetails === true &&
      (guardianNationality === undefined ||
        guardianNationality === '' ||
        guardianSameNationality === undefined ||
        guardianFamilyName === undefined ||
        guardianFamilyName === '' ||
        guardianGivenName === undefined ||
        guardianGivenName === '' ||
        guardianDob === undefined ||
        guardianDob === '' ||
        guardianPlaceOfBirth === undefined ||
        guardianPlaceOfBirth === '' ||
        guardianTravellingWith === undefined ||
        guardianTravellingWith === '' ||
        (isPersonTravellingWith(guardianTravellingWith) &&
          (guardianUkVisa === undefined ||
            guardianHasPassport === undefined ||
            (guardianHasPassport === true &&
              (guardianPassportNumber === undefined || guardianPassportNumber === '')))) ||
        dobError !== ''))
  ) {
    complete = false;
  }

  return { complete };
}
